import HistoryParam from './HistoryParam';

export default HistoryParam;
